import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import {Link} from "react-router-dom";
function Block8() {

    return (
            <section className="layout-pt-20 layout-pb-20">
                <div className="auto-container">

                    <div className="sec-title-outer">
                        <div className="sec-title" style={{width: "100%", textAlign: "center"}}>
                            <h2 className="homepage">Nos solutions <span>pour sensibiliser</span>, engager et faire progresser vos équipes</h2>
                            <div className="text homepage">
                                <b>Webinaires, formations, forums en ligne et hotline</b> :
                                Talents Handicap vous propose des dispositifs complémentaires pour
                                faire vivre votre politique handicap au quotidien, sensibiliser
                                durablement vos équipes et accompagner vos managers avec des outils concrets et opérationnels.
                            </div>
                        </div>
                    </div>

                    <div className="row wow fadeInUp">
                        <div className="banner-style-one -type-2 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-box"
                                 style={{backgroundImage: "url('images/index-13/banner/banner-generique.jpg')", backgroundPositionX: "center"}}>
                                <div className="content">
                                    <h3>Forums en ligne Talents Handicap</h3>
                                    <p>Recrutez des talents en situation de handicap et valorisez votre engagement grâce à des événements en ligne dédiés et ciblés.</p>
                                    <Link to="https://www.talents-handicap.com/" rel="noopener noreferrer" target="_blank" className="theme-btn homepage btn-style-six small mt-3">Rejoignez nos forums</Link>
                                </div>
                                <figure className="image" style={{display: "none"}}><img src="images/resource/employ.png" alt=""/></figure>
                            </div>
                        </div>
                        <div className="banner-style-two homepage -type-2 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-box"
                                 style={{backgroundImage: "url('images/index-13/banner/banner-thf.jpg')", backgroundPositionX: "center"}}>
                                <div className="content">
                                    <h3 className="color-dark-1">Talents Handicap Formation</h3>
                                    <p className="color-dark-2">Des formations inclusives pour sensibiliser vos équipes et vos managers aux enjeux du handicap et faire évoluer durablement les pratiques.</p>
                                    <Link to="https://formation.talents-handicap.com/" rel="noopener noreferrer" target="_blank" className="theme-btn homepage btn-style-one small mt-3">Découvrez nos formations</Link>
                                </div>
                                <figure className="image" style={{display: "none"}}><img src="images/resource/candidate.png" alt=""/></figure>
                            </div>
                        </div>
                    </div>
                    <div className="row wow fadeInUp justify-content-center">
                        <div className="banner-style-one -type-2 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-box"
                                 style={{backgroundImage: "url('images/resource/banner-candidat.jpg')", backgroundPositionX: "center"}}>
                                <div className="content">
                                    <h3>Hotline Talents Handicap</h3>
                                    <p>Un service dédié pour répondre aux questions sur le handicap au travail et accompagner vos équipes au quotidien.</p>
                                    <Link to="https://hotline.talents-handicap.com/" rel="noopener noreferrer" target="_blank" className="theme-btn homepage btn-style-six small mt-3">Découvrez la hotline</Link>
                                </div>
                                <figure className="image" style={{display: "none"}}><img src="images/resource/employ.png" alt=""/></figure>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
    )
}

export default Block8;
